import DueDate from "../domain/DueDate";
// import DateFormat from "../presentation/DateFormat";
// import DateForm from "./DateForm";
import React, {useState} from "react";
import DateForm from "./DateForm";
import DisplayDueDate from "./DisplayDueDate";
import ListMenu from "./ListMenu";
import {Helmet} from "react-helmet-async";
// import dueDate from "../domain/DueDate";

const FromTiming = () => {
    const initDate = new Date().toISOString().substring(0, 10).replace('/', '-');
    const [date, setDate] = useState<string>(initDate);
    // const [formattedDate, setFormattedDate] = useState<string>("");
    const [dueDate, setDueDate] = useState<DueDate | null>(null);
    // const [isDisplayResult, setIsDisplayResult] = useState<boolean>(false);
    const calcDueDate = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // const dueDate = DueDate.createFromTiming(new Date(date));
        setDueDate(DueDate.createFromTiming(new Date(date)));
        // setFormattedDate(DateFormat.fullDate(dueDate.get()));
    }
    const message = <span>パートナーとのタイミングは<br className="disabled:lg:"/>いつですか？</span>
    const pageTitle = '仲良しした日から出産予定日を計算する。'
    return (
        <div>
            <Helmet>
                <title>{pageTitle}</title>
            </Helmet>
            <div className="w-full flex justify-center items-center">
                <div className="bg-neutral text-lightShade px-4 py-16 w-full">
                    <div className="bg-white mx-auto w-11/12 rounded-xl p-5 md:w-6/12 lg:w-4/12">

                        <DisplayDueDate dueDate={dueDate}/>

                        <DateForm message={message} date={date} setDate={setDate} calcDueDate={calcDueDate}/>


                    </div>
                </div>
            </div>
            <ListMenu/>
        </div>
    )
}

export default FromTiming
